import "./App.css";
import Header from "./Header";
import Nav from "./Nav";
import Main from "./Main";
import Footer from "./Footer";


function Homepage() {
 const styles = {
  main: {
   display: "flex",
   flexDirection: "column",
  },
 };
 return (
  <>
    <Header>
    <Nav />
    </Header>
    <div className={styles}>
    <Main />
    </div>

   <Footer />
  </>
 );
}

export default Homepage;
